import module from './module.js'
// Components
import './components/component.js'
import './components/inventario/component.js'
import './components/inventario/lista/component.js'
import './components/inventario/sucursales/component.js'
import './components/launcher/component.js'
import './components/productosmasvendidos/component.js'
import './components/productosmasvendidos/datos/component.js'
import './components/saldosclientes/component.js'
import './components/saldosclientes/datos/component.js'
// Services
import './services/Catalogos/Sucursales.js'
import './services/Inventario/Csv.js'
import './services/InventarioService.js'
import './services/ProductosmasVendidosService.js'
import './services/SaldosclientesService.js'
// Routes
import './routes/reportesexternos-inventario.js'
import './routes/reportesexternos-productosmasvendidos.js'
import './routes/reportesexternos-saldosclientes.js'
import './routes/reportesexternos.js'

export default module.name



// WEBPACK FOOTER //
// ./src/contabilidad/reportesexternos/index.js